import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Header from './Header'
import ErrorCard from './ErrorCard'
import Container from './utils/Container'
import Faq from '../pages/Faq'
import HomeContainer from '../containers/HomeContainer'
import LockerContainer from '../containers/LockerContainer'
import faqs from '../pages/Faq/question.json'
import faqsLockers from '../pages/Faq/question-lockers.json'

function App() {
  return (
    <Container>
      <Header />
      <Router>
        <Switch>
          <Route
            path="/collect/faq"
            exact
            render={props => <Faq {...props} faqs={faqs} />}
          />
          <Route
            path="/collect/faq/locker"
            render={props => <Faq {...props} faqs={faqsLockers} />}
          />
          <Route path="/collect/locker/:orderId" component={LockerContainer} />
          <Route path="/collect/:orderId" component={HomeContainer} />
          <Route path="*" component={ErrorCard} />
        </Switch>
      </Router>
    </Container>
  )
}

export default App
